<template>
  <div class="row mb-4">
    <div class="col-lg-4 col-md-4 col-8">
      <span class="resultado-productos">
        {{ transPeralbaPro.item909 }} {{ count }} {{ transPeralbaPro.item910 }}
      </span>
    </div>

    <div class="col-lg-8 col-md-8 col-4">
      <div class="top-filters">
        <div class="form-group" :class="{ 'me-2': mobile == true }">
          <div class="input-group kd-filter-top kd-sortby">
            <div
              class="input-group-prepend input-group-select-order-products"
              v-if="mobile"
            >
              <span
                class="input-group-text"
                data-bs-toggle="modal"
                data-bs-target="#orderModal"
                v-if="mobile"
              >
                <img
                  src="/front/hi/sortby.svg"
                  class="svg-inline--fa fa-sort-amount-down fa-w-16 uppercase"
                />
              </span>
            </div>
            <div
              class="input-group-prepend input-group-select-order-products"
              v-else
              style="width: 300px; position: relative; height: 40px;"
            >
              <span
                style="position:absolute; left:0; bottom:0; width: 140px;"
                id="span-ordenar"
                class="input-group-text"
              >
                <img
                  src="/front/hi/sortby.svg"
                  class="svg-inline--fa fa-sort-amount-down fa-w-16 me-2 uppercase"
                />
                {{ transPeralbaPro.item911 }}
              </span>
              <select
                style="position:absolute; left:0; bottom:0; width: 300px; text-align: right; padding-bottom: 8px;"
                id="select-order-products"
                @change="handleOrderChange"
                class="form-control"
                data-action="filter"
                data-item="sort"
                v-model="selectedOrder"
              >
                <option data-by="relevancia" value="rel">{{
                  transPeralbaPro.item912
                }}</option>
                <option data-by="precio" value="desc">{{ item13 }}</option>
                <option data-by="precio" value="asc">{{ item14 }}</option>
                <option data-by="best_sellers" value="sales">{{
                  transPeralbaPro.item881
                }}</option>
                <option data-by="stock" value="stock_web">{{
                  transPeralbaPro.item315
                }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-group kd-filter-top kd-sortby">
            <div
              class="input-group-prepend input-group-select-order-products"
              v-if="mobile"
            >
              <span
                class="input-group-text"
                data-bs-toggle="modal"
                data-bs-target="#quantityModal"
                v-if="mobile"
              >
                <img
                  src="/front/hi/quantity.svg"
                  class="svg-inline--fa fa-sort-amount-down fa-w-16 me-2 uppercase"
                />
                {{ productsCountToShow }}
              </span>
            </div>
            <div
              class="input-group-prepend input-group-select-order-products"
              v-else
              style="width: 150px; position: relative; height: 40px;"
            >
              <span
                style="position:absolute; left:0; bottom:0; width: 100px;"
                id="span-quantity"
                class="input-group-text"
              >
                <img
                  src="/front/hi/quantity.svg"
                  class="svg-inline--fa fa-sort-amount-down fa-w-16 me-2 uppercase"
                />
                {{ transPeralbaPro.item1205 }}
              </span>
              <select
                style="position: absolute; left: 0px; bottom: 0px; width: 150px; text-align: right; padding-bottom: 8px;"
                id="select-quantity-products"
                @change="handleQuantityChange"
                class="form-control"
                data-action="filter"
                data-item="sort"
                v-model="quantity"
              >
                <option data-by="25" value="25">25</option>
                <option data-by="50" value="50">50</option>
                <option data-by="100" value="100">100</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group toggle-list-grid-products">
          <div class="input-group kd-filter-top kd-showas">
            <div
              class="input-group-prepend"
              @click="changeTemplate(0)"
              :class="{ 'kd-disabled': template == 1 }"
            >
              <span class="input-group-text">
                <img src="/front/hi/list.svg" class="svg-inline--fa fa-w-16" />
              </span>
            </div>
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                @click="changeTemplate(1)"
                :class="{ 'kd-disabled': template == 0 }"
              >
                <img src="/front/hi/grid.svg" class="svg-inline--fa fa-w-16" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 p-0" v-if="mobile">
      <button
        type="button"
        class="btn-per-filtros mt-2"
        data-bs-toggle="modal"
        data-bs-target="#filtersModal"
      >
        <img src="/front/hi/filter.svg" /> {{ transPeralbaPro.item902 }}
      </button>
    </div>

    <!-- Modal -->
    <div
      class="modal right fade"
      id="orderModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="
    orderModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="orderModalLabel">
              {{ transPeralbaPro.item911 }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mobile-order-products-list">
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('rel')"
              >
                <input
                  type="radio"
                  name="order"
                  value="rel"
                  @change="handleOrderChangeMobile('rel')"
                />
                <span>{{ transPeralbaPro.item912 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('desc')"
              >
                <input
                  type="radio"
                  name="order"
                  value="desc"
                  @change="handleOrderChangeMobile('desc')"
                />
                <span>{{ item13 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('asc')"
              >
                <input
                  type="radio"
                  name="order"
                  value="asc"
                  @change="handleOrderChangeMobile('asc')"
                />
                <span>{{ item14 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('sales')"
              >
                <input
                  type="radio"
                  name="order"
                  value="sales"
                  @change="handleOrderChangeMobile('sales')"
                />
                <span>{{ transPeralbaPro.item881 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('stock_web')"
              >
                <input
                  type="radio"
                  name="order"
                  value="stock_web"
                  @change="handleOrderChangeMobile('stock_web')"
                />
                <span>{{ transPeralbaPro.item315 }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn-per-dark w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              {{ transPeralbaPro.item905 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal right fade"
      id="quantityModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="
    quantityModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="quantityModalLabel">
              {{ transPeralbaPro.item1205 }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mobile-order-products-list">
              <div
                class="item-order-products-list"
                @click.prevent="clickQuantityChangeMobile(25)"
              >
                <input
                  type="radio"
                  name="quantity"
                  value="25"
                  @change="handleQuantityChangeMobile(25)"
                />
                <span>25</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickQuantityChangeMobile(50)"
              >
                <input
                  type="radio"
                  name="quantity"
                  value="50"
                  @change="handleQuantityChangeMobile(50)"
                />
                <span>50</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickQuantityChangeMobile(100)"
              >
                <input
                  type="radio"
                  name="quantity"
                  value="100"
                  @change="handleQuantityChangeMobile(100)"
                />
                <span>100</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn-per-dark w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              {{ transPeralbaPro.item905 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "page-control",
  filters: {
    uppercase: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  props: [
    "count",
    "query",
    "item10",
    "item11",
    "item12",
    "item13",
    "item14",
    "item15",
    "template",
    "mobile",
    "transPeralbaPro",
    "productsCountToShow",
    "order",
  ],
  data() {
    return {
      selectedOrder: null,
      quantity: 25,
    };
  },
  created() {
    this.selectedOrder = this.order;
    this.quantity = this.productsCountToShow;
  },
  methods: {
    changeTemplate(template) {
      console.log(event);
      this.$emit("onChangeTemplate", template);
    },
    handleOrderChange(event) {
      this.$emit("onOrderChange", event.target.value);
    },
    handleQuantityChange(event) {
      console.warn(event);
      this.$emit("onQuantityChange", event.target.value);
    },
    clickOrderChangeMobile(orderBy) {
      console.log("click row");
      const input = this.$el.querySelector(`input[value="${orderBy}"]`);
      if (input) {
        input.checked = true;
        this.handleOrderChangeMobile(orderBy);
      }
    },
    clickQuantityChangeMobile(quantity) {
      console.log("click row quant " + quantity);
      const input = this.$el.querySelector(`input[value="${quantity}"]`);
      if (input) {
        input.checked = true;
        this.productsCountToShow = quantity;
        this.handleQuantityChangeMobile(quantity);
      }
    },
    handleOrderChangeMobile(orderBy) {
      console.log("emit");
      this.$emit("onOrderChange", orderBy);
    },
    handleQuantityChangeMobile(quantity) {
      console.log("emit");
      this.$emit("onQuantityChange", parseInt(quantity));
    },
  },
};
</script>
